<main id="main-content" class="ds-product-page trust-page">
  <header class="trust-hero">
    <p class="ds-eyebrow">{{ page.eyebrow }}</p>
    <h1>{{ page.title }}</h1>
    <p class="trust-lede">{{ page.description }}</p>
    <p class="trust-updated">Last reviewed {{ page.updated }}</p>
  </header>
  <div class="trust-layout">
    <aside dsCard aria-label="On this page">
      <strong>On this page</strong>
      <nav>
        @for (section of page.sections; track section.title; let index = $index) {
          <a [href]="'#section-' + index">{{ section.title }}</a>
        }
      </nav>
    </aside>
    <article dsCard class="trust-article">
      @for (section of page.sections; track section.title; let index = $index) {
        <section [id]="'section-' + index">
          <h2>{{ section.title }}</h2>
          @for (paragraph of section.paragraphs; track paragraph) {
            <p>{{ paragraph }}</p>
          }
        </section>
      }
    </article>
  </div>
</main>
